import { normalizeInvitePermissions } from './invitePermissionLabels.js';
/**
 * Backend build/release historically use truthiness. Do not normalize the
 * persisted flags here: doing so changes access for legacy records.
 * This is a resource permission check, not token/MFA/IP authorization.
 */
export function canPerformBackendAppAction(evidence, action) {
    var _a, _b;
    switch (action) {
        case 'app.build':
            return evidence.role === 'owner' || !!((_a = evidence.permissions) === null || _a === void 0 ? void 0 : _a.canBuild);
        case 'app.release':
            return evidence.role === 'owner' || !!((_b = evidence.permissions) === null || _b === void 0 ? void 0 : _b.canRelease);
        default:
            return false;
    }
}
/** UI and Firestore app edits use strict booleans, unlike backend actions. */
export function getAppCapabilities(evidence) {
    const owner = evidence.role === 'owner';
    const { canBuild, canRelease, isAdmin } = normalizeInvitePermissions(evidence.permissions);
    return {
        /** Owner-only actions, such as deleting the app or its certificates. */
        canAdminister: owner || isAdmin,
        canBuild: owner || canBuild,
        canEdit: owner || canBuild || canRelease,
        canRelease: owner || canRelease,
    };
}
/** Preserve enumeration order for existing permission-subset error messages. */
export function permissionsOutsideGrant(requested, allowed) {
    return Object.keys(requested).filter((key) => requested[key] && !allowed[key]);
}
/** Legacy ownership mapping. This is not sufficient to authorize an action. */
export function isAccountOwner(actor, account) {
    return actor.userId === account.accountId;
}
